var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('rate',{attrs:{"rate":_vm.rate_info,"scene":"cdbirb","jump_page":"/packageA/loan_computer/loan_rate"}}),_c('page-wrap',{attrs:{"title":"房贷利率"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }